const sub_requests_headers = [
  "Transaction ID",
  "Name",
  "Plan Type",
  "Amount",
  "Coins",
  "Level",
  "Transaction Type",
  "Payment Date",
  "Status",
  "Actions",
];

const support_ticket_headers = [
  "Participant Name",
  "Role",
  "Title",
  "Status",
  "Total tickets",
  "Actions",
];

const reported_book_headers = [
  "Book Name",
  "Published by",
  "Role",
  "Reported Date",
  "Report reason",
  "Actions",
];

const feature_book_headers = [
  "Book name",
  "Published by",
  "Duration",
  "Cover Request",
  "Actions",
];

const headers_enums = {
  sub_requests_headers: 0,
  support_ticket_headers: 1,
  feature_book_headers: 2,
  reported_book_headers: 3,
};

const tab_enums_service = {
  sub_requests: 1,
  support_tickets: 2,
  feature_book: 3,
  reported_book: 4,
};

export {
  sub_requests_headers,
  support_ticket_headers,
  reported_book_headers,
  feature_book_headers,
  headers_enums,
  tab_enums_service,
};
